export let CriticalFailureReasons;
(function (CriticalFailureReasons) {
  CriticalFailureReasons["NONE"] = "NONE";
  CriticalFailureReasons["FETCH_TOKEN_ERROR"] = "FETCH_TOKEN_ERROR";
  CriticalFailureReasons["LIVE_NOTIFICATION_ERROR"] = "LIVE_NOTIFICATION_ERROR";
  CriticalFailureReasons["INBOUND_CALLING_DISABLED"] = "INBOUND_CALLING_DISABLED";
  CriticalFailureReasons["SETUP_TWILIO_DEVICE_ERROR"] = "SETUP_TWILIO_DEVICE_ERROR";
  CriticalFailureReasons["MICROPHONE_PERMISSION_ERROR"] = "MICROPHONE_PERMISSION_ERROR";
})(CriticalFailureReasons || (CriticalFailureReasons = {}));